import { axiosInstance } from "./AxiosInterceptor";
import { backendConfig } from "../config/BackendConfig";

export const getServiceToolLogs = (queryParam) => {
  /**End Point:- getLogs**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getLogs,
    queryParam
  );
};
